module.exports = __webpack_public_path__ + "static/media/goodEmoji.8d7f74a0.svg";